import { dataLayer } from 'analytics/data-layer';
import locator from 'utils/locator';

export const FEATURE_ELEMENT_EVENT_TYPE = {
  CLICK: 'click',
  IMPRESSION: 'impression',
} as const;

export type FeatureElementEventType =
  (typeof FEATURE_ELEMENT_EVENT_TYPE)[keyof typeof FEATURE_ELEMENT_EVENT_TYPE];

export const FEATURE_ELEMENT_ACTION = {
  ADD_ITEM_TO_LIST: 'add_item_to_list',
  DECREASE_ITEM_QUANTITY: 'decrease_item_quantity',
  INCREASE_ITEM_QUANTITY: 'increase_item_quantity',
  REMOVE_ITEM_FROM_LIST: 'remove_item_from_list',
} as const;

export type FeatureElementAction =
  (typeof FEATURE_ELEMENT_ACTION)[keyof typeof FEATURE_ELEMENT_ACTION];

export function trackFeatureElement({
  eventType,
  classification,
  feature,
  featureAction,
  featureElement,
}: {
  eventType: FeatureElementEventType;
  classification?: string;
  feature: string;
  featureAction?: FeatureElementAction;
  featureElement: string;
}) {
  dataLayer.push({
    event: `feature_element_${eventType}`,
    classification,
    feature,
    feature_element: featureElement,
    feature_action: featureAction,
    page_location: locator.origin + locator.pathname,
  });
}
